import axios, { AxiosResponse } from "axios";

import { getConfig } from "~/config";
import { PermissionScope } from "./types";

/**
 * Fetches the permission scope for the authenticated user
 * @param token - The authentication token
 * @returns Promise containing the permission scope data
 */
export async function fetchPermissionScope(
  token: string
): Promise<PermissionScope> {
  const endpoint = new URL(
    "api/kontax/taxops/self-permission",
    getConfig("VITE_APP_API_URL")
  ).toString();
  try {
    const response: AxiosResponse<PermissionScope> = await axios.get(endpoint, {
      headers: {
        "X-Auth-Token": token,
        Accept: "application/json",
      },
      validateStatus: (status) => status === 200,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = error.response?.data?.message || error.message;
      return Promise.reject(
        new Error(`Failed to fetch permission scope: ${message}`)
      );
    }
    return Promise.reject(error);
  }
}
